/**
 * creates code object from initialisation.worker body string for new Worker
 * @param       initialisation  worker function
 * @returns     new Worker      the instance of the created webworker
 */
export default function createWebWorker(worker) {
    // get body of worker function as string
    let code = worker.toString()
    code = code.substring(code.indexOf('{')+1, code.lastIndexOf('}'))

    // create data object url out of string
    const blob = new Blob([code], { type: 'application/javascript' })
    return new Worker(URL.createObjectURL(blob))
}